module.exports = __webpack_public_path__ + "static/9-9d09330fb24be561eeadbae9064dca90.jpg";